/* ==========================================================================
   Ajiaco y Frijoles — Carrusel
   Scroll-snap nativo + controles accesibles. Funciona sin JS (scroll táctil).
   ========================================================================== */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.ayfCarouselReady === 'true') return;
    root.dataset.ayfCarouselReady = 'true';

    var track = root.querySelector('[data-ayf-track]');
    var prev = root.querySelector('[data-ayf-prev]');
    var next = root.querySelector('[data-ayf-next]');
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || '16');
      return first.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateButtons);
    });

    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function initAll() {
    document.querySelectorAll('[data-ayf-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
